var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle52BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M11 26.5a1.5 1.5 0 0 1 1.5-1.5h35a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5h-35a1.5 1.5 0 0 1-1.5-1.5v-7Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M21.151 14.242a2.5 2.5 0 0 1-1.767 3.062L8.758 20.151a2.5 2.5 0 0 1-3.062-1.767l-2.588-9.66a2.5 2.5 0 0 1 1.768-3.062l10.625-2.847a2.5 2.5 0 0 1 3.062 1.768l2.588 9.66Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M20.763 12.793a1 1 0 0 1-1.225-.708l-1.941-7.244a1.5 1.5 0 0 0-1.837-1.06L5.134 6.626a1.5 1.5 0 0 0-1.06 1.837l1.94 7.245a1 1 0 1 1-1.931.518L2.142 8.982a3.5 3.5 0 0 1 2.475-4.287l10.625-2.847a3.5 3.5 0 0 1 4.287 2.475l1.94 7.245a1 1 0 0 1-.706 1.225Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54.304 18.384a2.5 2.5 0 0 1-3.062 1.767l-10.625-2.847a2.5 2.5 0 0 1-1.768-3.062l2.588-9.659A2.5 2.5 0 0 1 44.5 2.815l10.625 2.847a2.5 2.5 0 0 1 1.768 3.062l-2.588 9.66Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M54.692 16.934a1 1 0 0 1-.707-1.225l1.941-7.245a1.5 1.5 0 0 0-1.06-1.837L44.24 3.78a1.5 1.5 0 0 0-1.837 1.06l-1.94 7.245a1 1 0 1 1-1.933-.517l1.941-7.245a3.5 3.5 0 0 1 4.287-2.475l10.625 2.847a3.5 3.5 0 0 1 2.475 4.287l-1.941 7.245a1 1 0 0 1-1.225.707Z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M39.334 43.5a2.5 2.5 0 0 1 2.5-2.5H53.5a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5H39.334V43.5ZM21.666 43.5a2.5 2.5 0 0 1 2.5-2.5h11.667a2.5 2.5 0 0 1 2.5 2.5V56H21.667V43.5ZM4 43.5A2.5 2.5 0 0 1 6.5 41h11.667a2.5 2.5 0 0 1 2.5 2.5V56H6.5A2.5 2.5 0 0 1 4 53.5v-10Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M56 45a1 1 0 0 1 1 1v7.5a3.5 3.5 0 0 1-3.5 3.5h-47A3.5 3.5 0 0 1 3 53.5V46a1 1 0 1 1 2 0v7.5A1.5 1.5 0 0 0 6.5 55h47a1.5 1.5 0 0 0 1.5-1.5V46a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})));
SvgRectangle52BError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle52BError);
export default ForwardRef;